import { getEventTypeGroupFromJson } from '../../events/data_types'
import dataTypes from './data_types_config.json'

export const canadianFootballEventTypes = getEventTypeGroupFromJson(
  dataTypes,
  'Canadian Football'
)
